<button
  *ngIf="scrollable"
  class="scroll-left-button"
  [ngClass]="{ invisible: hideScrollLeft }"
  [attr.aria-controls]="tabListId"
  (click)="onScrollClick('left')"
>
  <app-icon [icon]="Icon.ChevronLeftSmall" [size]="16"></app-icon>
</button>
<div
  #tabList
  role="tablist"
  tabindex="-1"
  [id]="tabListId"
  [class]="class"
  [ngClass]="{
    'tab-list': true,
    'center-tabs': centerTabs
  }"
  (scroll)="onScroll()"
>
  <!-- Setting tabindex="-1" on tablist because otherwise it's focusable in firefox -->
  <ng-container *ngFor="let item of tabs">
    <button
      *ngIf="item.visible !== false"
      role="tab"
      [tabindex]="tabTabindex(item)"
      class="tab-list-item"
      [id]="tabId(item)"
      [class.disabled]="item.disabled"
      [class.error]="item.error"
      [class.selected]="item === activeTab"
      [ariaSelected]="item === activeTab"
      [attr.aria-controls]="item.ariaControls ?? ariaControlsInput ?? null"
      (click)="onTabClick(item)"
      (focus)="onTabFocus()"
      (keydown.arrowLeft)="onArrowLeftDown($event)"
      (keydown.arrowRight)="onArrowRightDown($event)"
    >
      <span class="item-content" [title]="tabContent(item)">{{ tabContent(item) }}</span>
      <span *ngIf="item.badge" [class]="item.badgeStyleClass">{{ item.badge }}</span>
    </button>
  </ng-container>
</div>
<button
  *ngIf="scrollable"
  class="scroll-right-button"
  [ngClass]="{ invisible: hideScrollRight }"
  [attr.aria-controls]="tabListId"
  (click)="onScrollClick('right')"
>
  <app-icon [icon]="Icon.ChevronRightSmall" [size]="16"></app-icon>
</button>
